import { createBrowserRouter } from 'react-router-dom';
import Login from './Login/Login';
import Home from './Home/Home';
import URLs from './URLs';
import Salon from './Salon/Salon';
import KpiResults from './KpiResults/KpiResults';
import { ActionPlan } from './ActionPlan/ActionPlan';
import GeneralInput from './GeneralInput/GeneralInput';
import { Error404Page } from './404/404';
import ProtectedLayout from '../components/Layout/ProtectedLayout';
import Auth from './Auth/Auth';

const router = createBrowserRouter([
  {
    path: URLs.ROOT,
    element: <ProtectedLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: URLs.Salon, element: <Salon /> },
      { path: URLs.SalonAfterPlanSent, element: <Salon /> },
      { path: `${URLs.Salon}/${URLs.NewPlan}`, element: <GeneralInput /> },
      { path: `${URLs.Salon}/${URLs.ActionPlan}`, element: <ActionPlan /> },
      { path: `${URLs.Salon}/${URLs.KpiResults}`, element: <KpiResults /> },
    ],
  },
  {
    path: URLs.Login,
    element: <Login />,
  },
  {
    path: URLs.Auth,
    element: <Auth />,
  },
  { path: '*', element: <Error404Page /> },
]);

export default router;
